import React from 'react';
import { Tag } from '@myua/kit';
import * as tagActions from '../../tag/actions';
import { BindTagsButtonSingle, useCanBindTags } from '../../tagBinder/components/BindTagsButton';
import { TagSimple } from '../../../api';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedIdsIndexed } from '../../tag/selectors';

export const Tags: React.FC<{ tags: TagSimple[] }> = ({ tags }) => {
  const dispatch = useDispatch();
  const selectedTags = useSelector(getSelectedIdsIndexed);
  const canBindTags = useCanBindTags();

  if (!canBindTags && tags.length === 0) {
    return null;
  }

  return (
    <div className="al-finder-details-tags">
      {tags.map((tag) => (
        <Tag.CheckableTag
          key={tag.id}
          size="small"
          checked={Boolean(selectedTags[tag.id])}
          className={`al-finder-details-tags__tag ${
            selectedTags[tag.id] ? 'al-finder-details-tags__tag_selected' : ''
          }`}
          onClick={() => {
            let newTags = tags.filter(({ id }) => selectedTags[id]);
            if (selectedTags[tag.id]) {
              newTags = newTags.filter(({ id }) => id !== tag.id);
            } else {
              newTags.push(tag);
            }
            dispatch(
              tagActions.tagsSelected({
                ids: newTags.map(({ id }) => id),
                saveLastState: true,
                log: { tags: newTags },
              }),
            );
          }}
        >
          {tag.name}
        </Tag.CheckableTag>
      ))}
      <BindTagsButtonSingle showText={tags.length === 0} />
    </div>
  );
};
